import SupplierHeats from "@/pages/chemistries/supplier-heats";
import LabDashboard from "@/pages/chemistries/lab-dashboard";
import ChemistriesReport from "@/pages/chemistries/report";
import Chemistries from "@/pages/lab/chemistries";
import LabChemistryRanges from "@/pages/lab/chemistry-ranges";
import LabTensileRequirements from "@/pages/lab/tensile-requirements";
import LabTestsBySection from "@/pages/lab/tests-by-section";

export const routeLabChemistries = "/lab/chemistries";
export const routeChemistriesReport = "/chemistries/report";
export const routeLabDashboard = "/lab/dashboard";
export const routeLabSupplierHeats = "/lab/supplier-heats";
export const routeLabTestsBySection = "/lab/tests-by-section";
export const routeLabChemistryRanges = "/lab/chemistry-ranges";
export const routeLabTensileRequirements = "/lab/tensile-requirements";
export const labChemistriesPermission = "ui.navbar.lab.chemistries";
export const labChemistriesReportPermission =
	"ui.navbar.lab.chemistries.report";
export const labDashboardPermission = "ui.navbar.lab.dashboard";
export const labSupplierHeatsPermission = "ui.navbar.lab.supplier.heats";
export const labTestsBySectionPermission = "ui.navbar.lab.tests.by.section";
export const labChemistryRangesPermission = "ui.navbar.lab.chemistry.ranges";
export const labTensileRequirementsPermission =
	"ui.navbar.lab.tensile.requirements";

export const labRoutes = [
	{
		path: routeLabChemistries,
		element: <Chemistries />,
		permission: labChemistriesPermission,
	},
	{
		path: routeChemistriesReport,
		element: <ChemistriesReport />,
		permission: labChemistriesReportPermission,
	},
	{
		path: routeLabDashboard,
		element: <LabDashboard />,
		permission: labDashboardPermission,
	},
	{
		path: routeLabSupplierHeats,
		element: <SupplierHeats />,
		permission: labSupplierHeatsPermission,
	},
	{
		path: routeLabTestsBySection,
		element: <LabTestsBySection />,
		permission: labTestsBySectionPermission,
	},
	{
		path: routeLabChemistryRanges,
		element: <LabChemistryRanges />,
		permission: labChemistryRangesPermission,
	},
	{
		path: routeLabTensileRequirements,
		element: <LabTensileRequirements />,
		permission: labTensileRequirementsPermission,
	},
];
